// extracted by mini-css-extract-plugin
module.exports = {"parent":"UserPanel_parent__28Iie","no":"UserPanel_no__2e4Ew","td":"UserPanel_td__RZ3MK","button":"UserPanel_button__wWn5t","import":"UserPanel_import__ax4Ua"};